import React from 'react';
import ModernModelSelector from './ModernModelSelector';

const CustomDropdown = (props) => {
  return <ModernModelSelector {...props} />;
};

export default CustomDropdown;
